<template>


    <div>
        <v-app>
            <!-- <v-skeleton-loader v-if="!loading" v-bind="attrs" type="article, article"></v-skeleton-loader> -->
            <!-- <v-form ref="frmItems">

                <v-row>

                

                      <v-col v-for="field in NotGroupFields" :key="field.id" cols="12" :md="field.cols || 12"
                        :sm="field.cols || 12" :lg="field.cols || 12" :xl="field.cols || 12">
                        <component v-if="field.grpName" v-model="field.value" v-bind:is="field.cmpName" :ayar="field" :edit="true"
                            :rules="field.rules" @triggerEvent="triggerEvent">
                            <template v-slot:group>
                                <v-row>
                                    <v-col v-for="fieldItem in listGrpNameFieldByGrpName(field.grpName)" cols="12"
                                        :md="fieldItem.cols || 12" :sm="fieldItem.cols || 12" :lg="fieldItem.cols || 12"
                                        :xl="fieldItem.cols || 12" :key="fieldItem.id">
                                        <component v-model="fieldItem.value" v-bind:is="fieldItem.cmpName" :edit="true"
                                            :ayar="fieldItem" :rules="fieldItem.rules" @triggerEvent="triggerEvent">
                                        </component>
                                    </v-col>
                                </v-row>

                            </template>

</component>
<component v-else v-model="field.value" v-bind:is="field.cmpName" :ayar="field" :edit="true" :rules="field.rules"
    @triggerEvent="triggerEvent">
</component>
</v-col>

</v-row>

<v-list subheader two-line v-if="loading" class="my-5">





    <v-list-item>
        <v-list-item-content>
            <table>
                <tr>
                    <td width="50"><span style="margin-bottom: 5px;;">Güvenlik Kodu: </span></td>
                    <td style="width: 100px;"><img :src="captchaImage" style="width: 100px; height: 40px;"
                            alt="Captcha" /></td>
                    <td style="width: 35px;"> <v-btn icon class="mx-2" fab dark color="teal"
                            @click="loadCaptcha"><v-icon>mdi-refresh</v-icon></v-btn></td>
                    <td><v-text-field :rules="rules" label="Güvenlik Kodu" v-model="userInputCaptha"></v-text-field>
                    </td>
                </tr>
            </table>





        </v-list-item-content>
    </v-list-item>

</v-list>
<v-card-actions>
    <v-spacer></v-spacer>
    <v-btn block color="primary" @click="dataSend()">
        Kaydet
    </v-btn>
</v-card-actions>
</v-form> @RepeatAppeal="onRepeatAppeal"-->
            <div v-if="saved">
                <form-saved-success :dis="false" :idParams="$route.params.id"></form-saved-success>
            </div>
            <FormViewRun2 v-else :edit="true" @saveClick="updateReturnFunc" :formSavedId="$route.params.id">
            </FormViewRun2>
        </v-app>




    </div>


</template>
<script>
//import { rules } from '@/plugins/custom.js'
import { numberSF, textSF, radioSF, selectSF, dateSF, mailSF, checkSF } from '@/plugins/FieldDataFormat.js'
import { ValueTurEnum } from '@/plugins/Enum';
import FormService from '@/services/FormService'

import FormViewRun2 from '@/components/FormViewRun2.vue';
import FormSavedSuccess from './FormSavedSuccess.vue';
import axios from 'axios';
import router from '@/router';
//import api from '@/plugins/axios';
export default {
    components: {
        // VText, VNumber, VRadio, VSelect, VDate, VMail, VCheck,VHtmlEditor,VFile,FormViewRun2
        FormViewRun2, FormSavedSuccess
    },
    name: 'FormViewRunEdit',

    data: () => ({
        saved: false,
        loading: false,
        rules: [v => !!v || 'Boş Bırakılamaz.'],
        fields: [],
        captchaImage: null,
        userInputCaptha: null,

        itemTypeList: [
            textSF,
            numberSF,
            radioSF,
            selectSF,
            dateSF,
            mailSF,
            checkSF,


        ]

    }),
    created() {
        // this.validate()
        //this.dataBind()
        this.loadCaptcha();
    },
    watch: {

        // selectedField: {
        //     immediate: true,
        //     handler() {

        //     },
        //     deep: true
        // }
    },
    computed: {

        validateDurumu() {


            // let value={id:this.$route.params.id,colums:fields.map(m=>({id:m.id,value:m.value}))};

            // console.log("object",value);



            return this.$refs.frmItems;
            // return   this.$refs.frmItems.validate();
        }
    },
    methods: {
        updateReturnFunc(returnApiValue) {
            if (returnApiValue.status == 200) {
                //this.$refs.fvr.reset();
                this.saved = true;

                //router.push({ name: 'FormSavedSuccess', params: { id: this.$route.params.id } })
            } else {
                this.$toast.warning(returnApiValue.data.label)
            }
            console.log("updateReturnFunc", returnApiValue);
        },
        checkVisibility(field) {

            if (!field.visibleIf) {
                return true;
            } else {
                if (field.visibleIf.conditions.length == 0) {
                    return true;
                }

            }


            const evaluateGroup = (group) => {
                const { logic = "AND", conditions = [] } = group;

                const results = conditions.map(cond => {
                    if (cond.conditions) {
                        // Nested group
                        return evaluateGroup(cond);
                    } else {
                        // Tek koşul
                        //console.log("this.formData",this.fields,cond.field);
                        const targetValue = this.fields.find(m => m.label == cond.field).value;// [cond.field];
                        // console.log("targetvalue",targetValue);
                        const { operator = "equals", value } = cond;

                        switch (operator) {
                            case "equals": return targetValue === value;
                            case "notEquals": return targetValue !== value;
                            case "contains": return targetValue && targetValue.toString().includes(value);
                            case "greater": return Number(targetValue) > Number(value);
                            case "greaterOrEqual": return Number(targetValue) >= Number(value);
                            case "less": return Number(targetValue) < Number(value);
                            case "lessOrEqual": return Number(targetValue) <= Number(value);
                            default: return true;
                        }
                    }
                });

                return logic === "AND"
                    ? results.every(Boolean)
                    : results.some(Boolean);
            };
            if (!evaluateGroup(field.visibleIf)) {
                field.value = "";
            }

            return field.visibleIf.goster == "goster" ? evaluateGroup(field.visibleIf) : !evaluateGroup(field.visibleIf);
        },
        listGrpNameFieldByGrpName(grpName) {
            let selected = this.fields.filter(m => m.type != "html" && m.grpName == grpName)

            return selected;
        },
        reset() {
            console.log("Form reset Çalıştı",);
            this.$refs.frmItems.reset();
        },
        loadCaptcha() {


            axios.get('https://localhost:7211/api/captcha/generate', {
                withCredentials: true, // session için gerekli

            }
            ).then((result) => {
                console.log("loadCaptcha", result);
                this.captchaImage = result.data.image;
                // this.$toast.success("Başarılı bir şekilde kaydedilmiştir.")
            }).catch((err) => {
                this.$toast.warning(err)
            });





        },
        // dataSend() {

        //     if (this.$refs.frmItems.validate()) {
        //         const formData = new FormData();
        //           let currentDataItems = this.fields.filter(m => m.type != "html");
        //             currentDataItems.forEach(element => {

        //             if (element.type == "file") {
        //                 if (Array.isArray(element.value)) {
        //                     element.value.forEach(itemFile => {
        //                        // console.log("ID", element.id, "ItemFile", itemFile);
        //                         formData.append(element.id, itemFile);
        //                     });
        //                 }
        //                 else {
        //                     formData.append(element.id, element.value);
        //                 }
        //             }
        //             else {
        //                 formData.append(element.id, element.value);
        //             }


        //         });
        //         // this.fields.forEach(element => {
        //         //     if (element.type != "html") {
        //         //         formData.append(element.id, element.value);
        //         //     }

        //         // });
        //        // console.log("Form Data:", formData.values());

        //         // Dosyayı ekle
        //         // if (this.selectedFile) {
        //         //     formData.append('file', this.selectedFile);
        //         // }

        //         try {
        //             axios.post(process.env.VUE_APP_APIURL + '/api/form/upload-dynamicEdit/' + this.$route.params.id, formData, {
        //                 withCredentials: true,
        //                 headers: {
        //                     'Content-Type': 'multipart/form-data',
        //                     'code': this.userInputCaptha,


        //                 }
        //             }).then((result) => {
        //                 this.$toast.success("Başarılı bir şekilde kaydedilmiştir.");
        //                 if (result.data.isFormId) {
        //                     router.push({ name: 'kullaniciDashboard', params: { id: result.data.formId }})

        //                 }
        //                 else
        //                 {
        //                             router.push({ name: 'KullaniciFormListesi'})
        //                 }

        //             }).catch((err) => {
        //                 console.log("Error", err.response.data);
        //                 this.$toast.warning(err.response.data)
        //             });


        //         } catch (err) {
        //             console.error('Gönderim hatası:', err.response.data);
        //             alert('Gönderim sırasında hata oluştu.');
        //         }
        //     }







        //     //let value = { id: this.$route.params.id, colums: this.fields.map(m => ({ id: m.id, value: m.value })) };

        // },
        // dataBind() {
        //     let this2 = this;
        //     console.log('The id is: ' + this.$route.params.id);

        //     FormService.listFormItemsEdit(this.$route.params.id).then(function (response) {
        //         let edits = response.data;
        //         let matrixRowsJson = edits.filter(m => m.valueTur == ValueTurEnum.MatrixRow).map(x => JSON.parse(x.json));
        //         edits = edits.filter(m => m.valueTur != ValueTurEnum.MatrixRow);
              


        //         console.log("listFormItemsEdit:", response.data);
        //         console.log("edits:", edits);
        //         console.log("matrixRowsJson:", matrixRowsJson);
        //         this2.loading = true;
        //         this2.fields = edits.map(m => {
                 
        //             const jsonObj = JSON.parse(m.json);
        //             let itemEdit = null;
        //               console.log("jsonObj",jsonObj);
        //             if (m.valueTur == ValueTurEnum.Matrix) {
        //                 jsonObj.rows.forEach(element => {
        //                     let row = matrixRowsJson.find(x => x.id == element.id);
        //                     if (row!=undefined) {
        //                         if (row.type=="checkMatrix") {
        //                             element.value = row.value.split(',');
        //                         }
        //                           element.value = row.value
        //                     console.log("Element",element);
        //                     }
                          
        //                 });
        //                 itemEdit = {
        //                     ...jsonObj,
        //                     value: m.value,
        //                     valueTur: m.valueTur,
        //                 };
        //             }
        //             else {
        //                 itemEdit = {
        //                     ...jsonObj,
        //                     value: m.value,
        //                     valueTur: m.valueTur,
        //                 };
        //             }

        //             return itemEdit;


        //         });


        //         console.log("Items:", this2.fields);
 
        //     }).catch((err) => {
        //         console.log("listFormItems", err.response);
        //         if (err.response.status == 401) {
        //             router.push({ path: '/login' })
        //         }

        //     });
        // },
        // triggerEvent(e) {
        //     console.log("triggerEvent Parameter", e.id);
        //     let triggeredItem = this.fields.find(m => m.id == e.id);
        //     console.log("triggerEvent triggeredItem", triggeredItem);
        //     triggeredItem.store = [...e.values];
        // },

    }

}
</script>

<style scoped>
.theme--light.v-application {
    background: none !important;
}
</style>